import React from 'react';

import { TextInput } from 'cpool-components/input/TextInput';
import type { FieldValues } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { useApplicantInfoContext } from '~/features/leadDetails/context/ApplicantInfoContext.tsx';

type Props = {
    title: string;
    name: string;
    disabled?: boolean;
    placeholder?: string;
};

const TitleInput: React.FC<Props> = ({ disabled, name, placeholder, title }) => {
    const { control } = useFormContext();
    const { applicantId } = useApplicantInfoContext();

    return (
        <FormField<FieldValues, string | null> control={control} name={name}>
            {({ error, onBlur, onChange, value }) => (
                <TextInput
                    id={`${name}-${applicantId}`}
                    label={title}
                    labelClassName="h-8 w-[175px] shrink-0 justify-start"
                    value={value ?? ''}
                    onBlur={onBlur}
                    onChange={(event) => onChange(event.target.value)}
                    disabled={disabled}
                    error={error}
                    placeholder={placeholder}
                />
            )}
        </FormField>
    );
};

export default TitleInput;
